import { combineReducers } from 'redux';

import { LOGOUT_USER } from '../actions/types';
import aisles from './aisles';
import cart from './cart';
import clients from './clients';
import delay from './delay';
import draftOrders from './draft-orders';
import email from './email';
import euroNews from './euro-news';
import families from './families';
import images from './images';
import locations from './locations';
import order from './order';
import orderConfirm from './order-confirm';
import pendingOrders from './pending-orders';
import preorders from './preorders';
import products from './products';
import users from './users';
import virtualCart from './virtual-cart';

export const appReducer = combineReducers({
  aisles,
  cart,
  clients,
  delay,
  draftOrders,
  email,
  euroNews,
  families,
  images,
  locations,
  order,
  orderConfirm,
  pendingOrders,
  preorders,
  products,
  users,
  virtualCart,
});

export default (state, action) => {
  if (action.type === 'NOOP') {
    // eslint-disable-next-line no-console
    console.warn('Unimplemented no-op action', action);

    return state;
  }

  if (action.type === LOGOUT_USER) {
    // idbClearAllFamilies();
    state = undefined;
  }

  return appReducer(state, action);
};
